/* MKB 2026 — Clothing rail (sections/mkb-rail.liquid). The tees hang on a curved rail; hover (or tap) turns one to show its print,
   click (or tap again) opens it with sizes and Add to cart (theme cart drawer). Default: each tee once, still, centred.
   "Repeat" setting: the tees repeat to fill the rail, drift left and can be dragged. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noHover = window.matchMedia && matchMedia('(hover: none)').matches;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function Rail(root) {
    var self = this;
    this.root = root;
    this.stage = root.querySelector('[data-stage]');
    this.list = root.querySelector('[data-items]');
    this.barP = root.querySelector('[data-bar-path]');
    this.barS = root.querySelector('[data-bar-shadow]');
    this.hint = root.querySelector('[data-hint]');
    this.hintT = root.querySelector('[data-hint-text]');
    this.prog = root.querySelector('[data-prog]');
    this.repeat = root.dataset.repeat === 'true';
    this.speed = reduce || !this.repeat ? 0 : parseFloat(root.dataset.speed || '25') || 0;
    if (!this.repeat) root.classList.add('is-static');
    this.src = [].slice.call(this.list.querySelectorAll('[data-item]'));
    if (!this.src.length) {
      this.stage.style.display = 'none';
      if (window.Shopify && Shopify.designMode) { this.hintT.textContent = 'No products with a side photo yet: Products → the tee → Metafields → Rail side photo.'; }
      return;
    }
    this.products = this.src.map(function (li, k) { li.dataset.k = k; return JSON.parse(li.querySelector('[data-p]').textContent); });
    this.items = [];
    this.offset = 0; this.active = -1; this.visible = true; this.drag = null; this.justDragged = false; this.lastPointer = 'mouse';
    this.qv = root.querySelector('[data-qv]');
    document.body.appendChild(this.qv);
    this.hintDefault = noHover ? this.hintT.dataset.touch : this.hintT.dataset.hover;
    this.hintT.textContent = this.hintDefault;
    this.layout();
    this.bind();
    if ('ResizeObserver' in window) { new ResizeObserver(function () { self.layout(); }).observe(this.stage); }
    else { window.addEventListener('resize', function () { self.layout(); }); }
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (e) { self.visible = e[0].isIntersecting; }).observe(root); }
    this.t0 = 0;
    requestAnimationFrame(function f(t) { self.frame(t); requestAnimationFrame(f); });
  }

  Rail.prototype.layout = function () {
    var W = this.stage.clientWidth; if (!W) return;
    var h = this.src[0].offsetHeight || 400;
    if (W === this.W && h === this.h) return;
    this.W = W; this.h = h;
    var n = this.src.length;
    this.sp = this.repeat ? Math.round(h * (W < 750 ? .32 : .3)) : Math.round(Math.max(h * .3, Math.min(h * .55, (W - h * .3) / n)));
    this.maxOff = this.repeat ? 0 : Math.max(0, ((n - 1) * this.sp - (W - h * .4)) / 2);
    if (!this.repeat) this.offset = Math.max(-this.maxOff, Math.min(this.maxOff, this.offset));
    this.S = Math.max(0, Math.round(h * .5 - this.sp));
    this.top = Math.round(h * .05);
    this.sag = Math.min(h * .1, W * .035);
    this.root.style.setProperty('--hit', Math.round(this.sp * .92) + 'px');
    var need = Math.ceil((W + 2 * h) / this.sp) + 1;
    var m = this.repeat ? Math.max(n, Math.ceil(need / n) * n) : n;
    // keep the originals, then add or drop clones
    while (this.list.children.length < m) {
      var k = this.list.children.length % n, c = this.src[k].cloneNode(true);
      var sc = c.querySelector('[data-p]'); if (sc) sc.remove();
      c.dataset.k = k; c.classList.remove('is-on'); c.setAttribute('aria-hidden', 'true');
      var cb = c.querySelector('[data-open]'); if (cb) cb.tabIndex = -1;
      this.list.appendChild(c);
    }
    while (this.list.children.length > m) { this.list.lastElementChild.remove(); }
    this.items = [].slice.call(this.list.children).map(function (el) { return { el: el, k: +el.dataset.k, s: 0 }; });
    this.L = m * this.sp;
    this.active = -1; this.clearUI();
    // the rail: a parabola through (0, top), (W/2, top + sag), (W, top)
    var d = 'M0 ' + this.top + ' Q' + (W / 2) + ' ' + (this.top + 2 * this.sag) + ' ' + W + ' ' + this.top;
    this.barP.setAttribute('d', d); this.barS.setAttribute('d', d);
    this.place(true);
  };

  Rail.prototype.y = function (x) { var u = 2 * x / this.W - 1; return this.top + this.sag * (1 - u * u); };

  Rail.prototype.place = function (snap) {
    var L = this.L, sp = this.sp, W = this.W, h = this.h, w = h * .6, self = this, c = (this.items.length - 1) / 2;
    function base(i) { if (!self.repeat) return W / 2 + (i - c) * sp - self.offset; var b = i * sp - self.offset; return ((b % L) + L) % L - sp; }
    var ax = this.active >= 0 ? base(this.active) : null;
    this.items.forEach(function (it, i) {
      var x = base(i);
      var target = ax === null || i === self.active ? 0 : (x < ax ? -self.S : self.S);
      it.s = snap ? target : it.s + (target - it.s) * .16;
      var X = x + it.s;
      if (X < -w || X > W + w) { it.el.style.visibility = 'hidden'; return; }
      it.el.style.visibility = '';
      it.el.style.transform = 'translate3d(' + (X - w / 2).toFixed(1) + 'px,' + (self.y(X) - h * .02 - 4).toFixed(1) + 'px,0)';
    });
    if (this.prog) { var p = (((this.offset % L) + L) % L) / L; this.prog.style.transform = 'translateX(' + (p * 194).toFixed(1) + '%)'; }
  };

  Rail.prototype.frame = function (t) {
    var dt = this.t0 ? Math.min(.05, (t - this.t0) / 1000) : 0; this.t0 = t;
    if (!this.W) return;
    var paused = !this.visible || document.hidden || this.active >= 0 || this.drag || !this.qv.hidden;
    if (!paused && this.speed) this.offset += this.speed * dt;
    if (!this.visible && !this.drag) return;
    this.place(false);
  };

  Rail.prototype.setActive = function (i) {
    if (this.clearTimer) { clearTimeout(this.clearTimer); this.clearTimer = null; }
    if (i === this.active) return;
    if (this.active >= 0 && this.items[this.active]) this.items[this.active].el.classList.remove('is-on');
    this.active = i;
    var it = this.items[i]; if (!it) return;
    it.el.classList.add('is-on');
    var p = this.products[it.k];
    this.hint.classList.add('is-product');
    this.hintT.innerHTML = '<strong>' + esc(p.t) + '</strong>' + esc(p.p);
  };
  Rail.prototype.clearUI = function () {
    this.items.forEach(function (it) { it.el.classList.remove('is-on'); });
    this.hint.classList.remove('is-product');
    this.hintT.textContent = this.hintDefault;
  };
  Rail.prototype.clear = function (later) {
    var self = this;
    if (later) { this.clearTimer = setTimeout(function () { self.clearTimer = null; self.clear(false); }, 90); return; }
    if (this.active >= 0 && this.items[this.active]) this.items[this.active].el.classList.remove('is-on');
    this.active = -1; this.clearUI();
  };

  Rail.prototype.bind = function () {
    var self = this, st = this.stage;
    function idx(el) { var li = el.closest('[data-item]'); return self.items.findIndex(function (it) { return it.el === li; }); }
    st.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse' || self.drag) return;
      var b = e.target.closest('[data-open]'); if (b) self.setActive(idx(b));
    });
    st.addEventListener('pointerout', function (e) {
      if (e.pointerType !== 'mouse') return;
      var b = e.target.closest('[data-open]'); if (b && !(e.relatedTarget && b.contains(e.relatedTarget))) self.clear(true);
    });
    st.addEventListener('focusin', function (e) { var b = e.target.closest('[data-open]'); if (b && b.matches(':focus-visible')) self.setActive(idx(b)); });
    st.addEventListener('focusout', function (e) { if (!st.contains(e.relatedTarget)) self.clear(true); });
    st.addEventListener('pointerdown', function (e) {
      self.lastPointer = e.pointerType;
      if ((!self.repeat && !self.maxOff) || (e.button !== undefined && e.button !== 0)) return;
      self.drag = { x: e.clientX, o: self.offset, id: e.pointerId, moved: false };
    });
    st.addEventListener('pointermove', function (e) {
      var d = self.drag; if (!d || e.pointerId !== d.id) return;
      var dx = e.clientX - d.x;
      if (!d.moved && Math.abs(dx) > 6) { d.moved = true; st.classList.add('is-drag'); try { st.setPointerCapture(d.id); } catch (x) {} if (self.active >= 0) self.clear(false); }
      if (d.moved) self.offset = self.repeat ? d.o - dx : Math.max(-self.maxOff, Math.min(self.maxOff, d.o - dx));
    });
    function up(e) {
      var d = self.drag; if (!d || e.pointerId !== d.id) return;
      self.drag = null; st.classList.remove('is-drag');
      if (d.moved) { self.justDragged = true; setTimeout(function () { self.justDragged = false; }, 0); }
    }
    st.addEventListener('pointerup', up); st.addEventListener('pointercancel', up);
    st.addEventListener('click', function (e) {
      if (self.justDragged) { e.preventDefault(); return; }
      var b = e.target.closest('[data-open]');
      if (!b) { if (self.active >= 0) self.clear(false); return; }
      var i = idx(b);
      if (self.lastPointer !== 'mouse' && self.active !== i) { self.setActive(i); return; }
      self.open(self.items[i].k, b);
    });
    // quick view
    var q = this.qv;
    q.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return self.close();
      if (e.target.closest('[data-qv-prev]')) return self.open((self.k - 1 + self.products.length) % self.products.length);
      if (e.target.closest('[data-qv-next]')) return self.open((self.k + 1) % self.products.length);
      var th = e.target.closest('[data-thumb]'); if (th) return self.show(+th.dataset.thumb);
      var ch = e.target.closest('[data-chip]'); if (ch) { self.sel[+ch.dataset.o] = ch.dataset.v; return self.renderVariant(true); }
      if (e.target.closest('[data-qv-add]')) return self.add();
    });
    document.addEventListener('keydown', function (e) {
      if (q.hidden) return;
      if (e.key === 'Escape') self.close();
      if (e.key === 'Tab') {
        var f = [].slice.call(q.querySelectorAll('button:not([disabled]), a[href]')).filter(function (x) { return x.offsetParent; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  };

  Rail.prototype.open = function (k, from) {
    var q = this.qv, p = this.products[k];
    this.k = k; if (from) this.from = from;
    q.querySelector('[data-qv-count]').textContent = pad(k + 1) + ' / ' + pad(this.products.length);
    q.querySelector('[data-qv-title]').textContent = p.t;
    q.querySelector('[data-qv-link]').href = p.u;
    q.querySelector('[data-qv-thumbs]').innerHTML = p.imgs.length > 1 ? p.imgs.map(function (u, i) { return '<button type="button" data-thumb="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(u.replace(/width=\d+/, 'width=200')) + '" alt="" loading="lazy"></button>'; }).join('') : '';
    var first = p.vars.find(function (v) { return v.a; }) || p.vars[0];
    this.sel = first.o.slice();
    q.querySelector('[data-qv-opts]').innerHTML = p.opts.map(function (o, j) {
      if (o.v.length < 2 && /title/i.test(o.n)) return '';
      return '<div><p class="mkb-rail-qv__opt-l">' + esc(o.n) + '</p><div class="mkb-rail-qv__chips">' + o.v.map(function (v) { return '<button type="button" data-chip data-o="' + j + '" data-v="' + esc(v) + '">' + esc(v) + '</button>'; }).join('') + '</div></div>';
    }).join('');
    this.show(0);
    this.renderVariant(false);
    if (q.hidden) {
      q.hidden = false;
      this.prevOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      q.querySelector('.mkb-rail-qv__x').focus();
    }
  };
  Rail.prototype.show = function (i) {
    var q = this.qv, p = this.products[this.k], u = p.imgs[i] || p.imgs[0];
    if (u) q.querySelector('[data-qv-img]').src = u;
    [].forEach.call(q.querySelectorAll('[data-thumb]'), function (b) { b.setAttribute('aria-pressed', String(+b.dataset.thumb === i)); });
  };
  Rail.prototype.variant = function () {
    var sel = this.sel; return this.products[this.k].vars.find(function (v) { return v.o.every(function (x, j) { return x === sel[j]; }); });
  };
  Rail.prototype.renderVariant = function (changed) {
    var q = this.qv, p = this.products[this.k], sel = this.sel, v = this.variant();
    [].forEach.call(q.querySelectorAll('[data-chip]'), function (b) {
      var j = +b.dataset.o, val = b.dataset.v;
      b.setAttribute('aria-pressed', String(sel[j] === val));
      var ok = p.vars.some(function (x) { return x.a && x.o[j] === val && x.o.every(function (y, m) { return m === j || y === sel[m]; }); });
      b.classList.toggle('is-out', !ok);
    });
    q.querySelector('[data-qv-price]').textContent = v ? v.p : p.p;
    var add = q.querySelector('[data-qv-add]');
    add.disabled = !v || !v.a;
    add.textContent = !v ? 'Unavailable' : !v.a ? 'Sold out' : p.pre ? 'Pre-order' : 'Add to cart';
    q.querySelector('[data-qv-note]').textContent = p.pre && v && v.a ? 'Pre-order: we ship as soon as your size is ready.' : '';
    if (changed && v && v.img) { var i = p.imgs.indexOf(v.img); if (i >= 0) this.show(i); else q.querySelector('[data-qv-img]').src = v.img; }
  };
  Rail.prototype.add = function () {
    var self = this, q = this.qv, v = this.variant(), btn = q.querySelector('[data-qv-add]'), note = q.querySelector('[data-qv-note]');
    if (!v || !v.a) return;
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) {
      btn.disabled = false; btn.textContent = label;
      if (j.status) { note.textContent = j.description || j.message || 'Could not add this size.'; return; }
      self.close(true);
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.renderContents === 'function' && j.sections) { d.renderContents(j); }
      else { location.href = root + 'cart'; }
    }).catch(function () { btn.disabled = false; btn.textContent = label; note.textContent = 'Could not add this size. Please try again.'; });
  };
  Rail.prototype.close = function (keepFocus) {
    if (this.qv.hidden) return;
    this.qv.hidden = true;
    document.body.style.overflow = this.prevOverflow || '';
    if (!keepFocus && this.from && document.contains(this.from)) this.from.focus({ preventScroll: true });
    this.clear(false);
  };

  function init(scope) { [].forEach.call((scope || document).querySelectorAll('[data-mkb-rail]'), function (r) { if (!r.__rail) r.__rail = new Rail(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { [].forEach.call(e.target.querySelectorAll('[data-mkb-rail]'), function (r) { if (r.__rail && r.__rail.qv) r.__rail.qv.remove(); }); });
})();